
  var _styles = {
  "coupon-title": {
    "width": "100%",
    "display": "flex",
    "flexDirection": "row"
  },
  "coupon-title-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "overflow": "hidden"
  },
  "coupon-title-single": {
    "fontSize": "0.42667rem",
    "lineHeight": "0.58667rem"
  },
  "coupon-title-double": {
    "fontSize": "0.32rem",
    "lineHeight": "0.42667rem"
  },
  "coupon-title-triple": {
    "fontSize": "0.32rem",
    "lineHeight": "0.42667rem"
  }
};



  module.exports = _styles;
  